"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = require("../../component");
var element_1 = require("../../element");
var Section = /** @class */ (function (_super) {
    __extends(Section, _super);
    function Section() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.prepared = false;
        return _this;
    }
    Section.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._background = this.appendT(element_1.Arc).options({
            _startAngle: function (d, i, g, h) { return h.parOp("_fromAng"); },
            _endAngle: function (d, i, g, h) { return h.parOp("_toAng"); },
            _padAngle: function (d, i, g, h) { return h.parOp("_padAng"); },
            _padRadius: function () { return _this.parent.circos.outerRadius; },
            _innerR: function (d) { return _this.parent.getInnerR(d._key); },
            _outerR: function (d) { return _this.parent.getOuterR(d._key); },
            fill: function (d, i, g) {
                var bg = _this.parent.getOption("_background", d.data, i, g);
                if (typeof bg === "function") {
                    return bg(d._key);
                }
                return bg;
            },
            visibility: function (d) { return d.data === undefined ? "hidden" : "visible"; },
        });
    };
    Section.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        // renderers
        this.parent.renderers.forEach(function (renderer) { return renderer.prepareData(_this); });
        this.parent.renderers.forEach(function (renderer) { return renderer.renderSection(_this); });
        this.prepared = true;
    };
    return Section;
}(component_1.Component));
exports.Section = Section;
//# sourceMappingURL=section.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/section.js
// module id = 245
// module chunks = 0 1